import type { StatisticSectionRow } from '../../StatisticsV2/shared/StatisticsSectionsTable/types';
import {
  createStatisticCountCell,
  createStatisticPercentCell,
} from '../../StatisticsV2/shared/statisticCells';
import {
  formatCount,
  formatPercent,
} from '../../StatisticsV2/OutgoingStatistics/statisticsFormatters';
import { getIncomingStatisticTooltip } from './incomingStatisticTooltips';

interface MetricRowInput {
  readonly key: string;
  readonly section: string;
  readonly parameter: string;
  readonly numerator: number;
  readonly denominator: number | null | undefined;
  readonly percentDecimals?: number;
}

export const createIncomingMetricRow = ({
  key,
  section,
  parameter,
  numerator,
  denominator,
  percentDecimals = 2,
}: MetricRowInput): StatisticSectionRow => ({
  key,
  section,
  parameter,
  value: formatCount(numerator),
  percent: formatPercent(numerator, denominator, percentDecimals),
  cells: {
    value: createStatisticCountCell(numerator),
    percent: createStatisticPercentCell(
      numerator,
      denominator,
      percentDecimals,
    ),
  },
  level: 0,
  tooltip: getIncomingStatisticTooltip(key),
});

export const createIncomingSectionRow = (
  key: string,
  section: string,
  children: StatisticSectionRow[],
  subtitle?: string,
): StatisticSectionRow => ({
  key,
  section,
  parameter: section,
  value: '',
  percent: '',
  level: 0,
  children,
  ...(subtitle ? { subtitle } : {}),
});
